import React from "react"
import { connect } from "react-redux"
import styled, { css } from "styled-components"
import { Paragraph, ExpandableContainer, Arrow, Label, Link } from "buoy-core"
import { colors, fontWeight, fontSize, responsive } from "buoy-theme"
import { CardHeading, CardContainer } from "./CollapsibleFormCard"
import VisitReview from "./VisitReview"
import * as actions from "../actions"
import ReEntry from "./ReEntry"
import { samlHandoff } from "../../payment/actions"
import { SVG_URL } from "../../common/constants"

const VisitDetail = styled(Paragraph)`
  font-size: ${fontSize.bodyMain};
  margin: 0;
  line-height: 1.25;
  &:first-of-type {
    margin-bottom: 4px;
  }
`

const VisitDate = styled(Label)`
  margin: 0 0 12px;
  color: ${colors.neutral};
`

const VisitCardContainer = styled(CardContainer)`
  margin-bottom: 16px;
`

const VisitCardHeading = styled(CardHeading)`
  margin-bottom: 40px;
`

const SummaryContainer = styled.div`
  display: flex;
  ${responsive("flex-direction", "row", "row", "row", "row", "column")};
  justify-content: space-between;
`

const SummaryContent = styled.div`
  display: flex;
  flex-direction: column;
`

const Bold = styled.strong`
  ${fontSize("bodyMain")};
  font-weight: ${fontWeight.medium};
`

const VisitSummary = ({ visit, reEntry, samlHandoff }) => (
  <SummaryContainer>
    <SummaryContent>
      <VisitDate>
        {visit.time} {visit.name ? "for " + visit.name : ""}
      </VisitDate>
      <VisitDetail>
        <Bold>Symptoms</Bold>:{" "}
        {visit.presentation
          .filter(x => x.search)
          .map(x => x.search.replace(";", "; "))
          .join("; ")}
      </VisitDetail>
      <VisitDetail>
        <Bold>Matches</Bold>: {visit.differential.join("; ")}
      </VisitDetail>
    </SummaryContent>
    {reEntry !== undefined && (
      <ReEntry recent={reEntry} onClick={samlHandoff} />
    )}
  </SummaryContainer>
)

const getVisitTranscript = (
  getResults,
  setCurrentVisit,
  visit,
  currentVisit
) => {
  if (visit && currentVisit && visit.token === currentVisit.token) {
    setCurrentVisit(null)
  } else if (visit) {
    getResults(visit)
    setCurrentVisit(visit)
  }
}

const Separator = styled.hr`
  color: ${colors.neutralLighter};
`

const CustomExpanderContainer = styled.div`
  display: flex;
  align-items: center;
  ${fontSize("bodyMain")};
  font-weight: ${fontWeight.light};
  color: ${colors.primary};
  text-decoration: underline;
  margin: 8px 0px;
  cursor: pointer;
`

const ArrowContainer = styled.div`
  margin: 0 8px;
  ${props =>
    props.expanded
      ? css`
          transform: rotate(180deg);
        `
      : ""};
`

const LoadingWheel = () => (
  <img
    src={`${SVG_URL}loading-wheel.gif`}
    style={{ height: 36 }}
    alt="Loading"
  />
)

const CustomExpander = ({ expanded, onClick }) => (
  <CustomExpanderContainer onClick={onClick}>
    {expanded ? "collapse results" : "view results"}
    <ArrowContainer expanded={expanded}>
      <Arrow />
    </ArrowContainer>
  </CustomExpanderContainer>
)

const VisitReviewContainer = ({ error, transcript, visit }) =>
  error.status ? (
    <VisitDetail>{error.msg}</VisitDetail>
  ) : (
    <VisitReview getTranscript={transcript} visit={visit} />
  )

class VisitCard extends React.Component {
  componentDidMount() {
    if (this.props.visits.length === 0) {
      this.props.getVisits()
      this.props.getUserCharges()
    }
  }

  render() {
    let {
      visits,
      getResults,
      currentVisit,
      visitError,
      loading,
      setCurrentVisit,
      getTranscript,
      reEntry,
      samlHandoff,
    } = this.props
    return (
      <VisitCardContainer margin="0 0 16px 0">
        <VisitCardHeading>Visit History</VisitCardHeading>
        {visits.loading ? (
          <LoadingWheel />
        ) : visits.length > 0 ? (
          visits.map((visit, index) => (
            <React.Fragment>
              <ExpandableContainer
                key={index}
                dividerComponent={CustomExpander}
                bottomToggleComponent={CustomExpander}
                showBottom
                expanded={currentVisit && currentVisit.token === visit.token}
                mainContent={
                  <VisitSummary
                    key={visit.token}
                    visit={visit}
                    getResults={getResults}
                    reEntry={reEntry[visit.token]}
                    samlHandoff={samlHandoff}
                  />
                }
                expandedContent={
                  loading ? (
                    <LoadingWheel />
                  ) : (
                    <VisitReviewContainer
                      error={visitError}
                      transcript={getTranscript}
                      visit={currentVisit}
                    />
                  )
                }
                onToggle={() =>
                  getVisitTranscript(
                    getResults,
                    setCurrentVisit,
                    visit,
                    currentVisit
                  )
                }
              />
              {index + 1 < visits.length && <Separator />}
            </React.Fragment>
          ))
        ) : (
          <Paragraph>
            Your visit history is empty.{" "}
            <Link href="/symptom-checker/">Start a visit</Link>
          </Paragraph>
        )}
      </VisitCardContainer>
    )
  }
}

const mapStateToProps = state => ({
  currentVisit: state.account.currentVisit,
  reEntry: state.payment.reEntry,
  visitError: state.account.visitError,
  loading: state.loading,
})

const mapDispatchToProps = dispatch => ({
  setCurrentVisit: visit => dispatch(actions.setCurrentVisit(visit)),
  getTranscript: () => dispatch(actions.getVisitTranscript()),
  samlHandoff: () => dispatch(samlHandoff(true)),
})

const VisitCardWrapper = connect(mapStateToProps, mapDispatchToProps)(VisitCard)

export { VisitCardWrapper as default, VisitCard }



// WEBPACK FOOTER //
// ./assets/account/components/VisitCard.js